import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import routes from "../../app/routes";
import Table from "./Table";
import Form from "./Form";
import { closeAllTooltip } from "../../utils/closeAllTooltip";

export default function Index() {
  const [collection, setCollection] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [show, setShow] = useState(false);
  const closeForm = () => setShow(false);
  const openForm = () => setShow(true);
  const [initialFormValues, setInitialFormValues] = useState({});

  const updateCollection = () => {
    setLoaded(true);
    axios.get(routes.api.file_imports.list).then((resp) => {
      setCollection(resp.data.data);
      setLoaded(false);
    });
  };

  const editData = (data) => {
    closeAllTooltip();
    setInitialFormValues({
      id: data.id,
      enterprise: data.attributes.enterprise_id,
      team: data.attributes.enterprise_team_id,
    });
    openForm();
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h2>File Import Log</h2>
        </div>
      </div>
      <div>
        {loaded && <p className="text-center mt20">Processing...</p>}
        {!loaded && <Table collection={collection} editData={editData} />}
      </div>
      <Modal
        className="student inmodal auto without-overflow"
        show={show}
        onHide={closeForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            closeForm={closeForm}
            initialFormValues={initialFormValues}
            updateCollection={updateCollection}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
